import { ExpandMore, Search } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, FormHelperText } from "@mui/material";
import { Check } from "../../svgUrls";
import clsx from "clsx";

type WorkflowAccordionProps = {
  showNumber?: string;
  showTick?: boolean;
  title: string;
  subTitle?: string;
  isDisabled?: boolean;
  children?: React.ReactNode;
  expanded: boolean;
  setExpandedSection: (expandedSection: string) => void;
  showSearchIcon?: boolean;
  setShowSearchField?: (showSearchField: boolean) => void;
  showSearchField?: boolean;
}

const WorkflowAccordion = ({
  showNumber,
  showTick,
  title,
  subTitle,
  isDisabled,
  children,
  expanded,
  setExpandedSection,
  showSearchIcon,
  setShowSearchField,
  showSearchField
}: WorkflowAccordionProps) => {
  return <>
      <Accordion
        disabled={isDisabled}
        elevation={0}
        sx={{
            "&:before": {
                display: "none",
            },
            "&.Mui-disabled": {
              backgroundColor: "transparent",
            },
            "& .MuiAccordionSummary-content": {
              margin: "16px 0 !important"
            }
        }}
        className={clsx("!m-0", {"grayscale": isDisabled})}
        expanded={expanded}
        slotProps={{
          transition: {
            timeout: 0,
          }
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="!min-h-10"
          onClick={() => setExpandedSection(title)}
        >
          <div className="flex items-center gap-3 w-full">
            {
              showNumber ?
                <div className="rounded-[20px] bg-backgroundBlue text-xs font-semibold text-nanonetsBlue flex items-center justify-center h-5 w-5">
                  {showNumber}
                </div>
              : showTick ?
                <div className="rounded-[20px] bg-[#F0F8F1] flex items-center justify-center h-5 w-5">
                  <Check />
                </div>
              : null
            }
            <div className="flex-grow">
              <div className="font-medium text-sm">{title}</div>
              <FormHelperText className="text-xs">{subTitle}</FormHelperText>
            </div>
            {showSearchIcon && (
              <Search
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSearchField && setShowSearchField(!showSearchField);
                }}
                className="text-gray-600 ml-auto"
              />
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails className="!pt-0">
          <div className=" mb-4">
            {children}
          </div>
        </AccordionDetails>
      </Accordion>
      <hr className="mx-4 border-lightGrey" />
  </>
};
  
export default WorkflowAccordion;